import React from 'react'
import './Loading.scss';

export default function Loading() {
    return (
        <div className="loader">Loading...</div>
    )
}